<template>
  <CustomUpdateDialog
    dialogTitle="ارسال نوتیفیکیشن برای همه"
    dialogId="send-notif-to-all-confirmation-dialog"
    @ok="sendNotification"
    ok-title="تایید"
  >
    <BCol cols="12">
      <p>آیا از ارسال نوتیفیکیشن برای تمام کاربران اطمینان دارید؟</p>
    </BCol>
  </CustomUpdateDialog>
</template>

<script>
export default {
  emits: ["sendNotification"],
  methods: {
    sendNotification() {
      this.$bvModal.hide("send-notif-to-all-confirmation-dialog");
      this.$emit("sendNotification");
    },
  },
  components: {
    CustomUpdateDialog,
    BCol,
  },
};
import { BCol } from "bootstrap-vue";
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
</script>
